<template>
  <nav class="moo-bottom-nav" :style="{ '--nav-active': activeColor }">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      class="moo-bottom-nav__item"
      :class="{ 'moo-bottom-nav__item--active': tab.key === active }"
      type="button"
      @click="$emit('navigate', tab.key)"
    >
      <i class="material-icons-round moo-bottom-nav__icon" aria-hidden="true">{{ tab.icon }}</i>
      <span class="moo-bottom-nav__label">{{ tab.label }}</span>
    </button>
  </nav>
</template>

<script>
export default {
  name: "BottomNav",
  props: {
    // Active tab key: "menu" | "rewards" | "orders" | "profile".
    active: {
      type: String,
      default: "menu",
    },
    // M1051: the Sale Channel hides member Login and Rewards — drop those tabs.
    hideMember: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["navigate"],
  computed: {
    // Computed (not data) so the labels re-render when the locale changes.
    tabs() {
      return [
        { key: "menu", icon: "restaurant_menu", label: this.$t("nav.menu") },
        { key: "orders", icon: "receipt_long", label: this.$t("nav.orders") },
        {
          key: "rewards",
          icon: "card_giftcard",
          label: this.$t("nav.rewards"),
        },
        { key: "profile", icon: "person", label: this.$t("nav.profile") },
      ].filter((tab) => !this.hideMember || (tab.key !== "rewards" && tab.key !== "profile"));
    },
    // Merchant's Theme 2 colour for the active tab.
    activeColor() {
      return (
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color ||
        "#201a1a"
      );
    },
  },
};
</script>

<style scoped>
.moo-bottom-nav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  backdrop-filter: blur(12px);
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.04);
  padding: 12px 8px calc(12px + env(safe-area-inset-bottom, 0px));
}

.moo-bottom-nav__item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 4px 0;
  background: none;
  border: none;
  color: #9a9a9a;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.15s ease;
}

.moo-bottom-nav__item:active {
  transform: scale(0.92);
}

.moo-bottom-nav__icon {
  font-size: 26px;
}

.moo-bottom-nav__item--active {
  color: var(--nav-active);
}

.moo-bottom-nav__item--active .moo-bottom-nav__label {
  font-weight: 700;
}

.moo-bottom-nav__label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
</style>
